import { Button } from '@mui/material'
import { useAgencyInfo } from 'context/agency'
import { useAppServices } from 'hook/services'
import React, { useEffect, useState } from 'react'

const NonSaasPlanContactInfo = () => {
    const [inputs, setInputs] = useState({ email: '', phone: '', website: '' })
    const [loader, setLoader] = useState(false)
    const [agency] = useAgencyInfo();
    const service = useAppServices()
    const handleSaveClick = async () => {
        setLoader(true)
        await service.agency.update({
            payload: { _id: agency?._id, non_saas_email: inputs.email, non_saas_phone: inputs.phone, non_saas_website: inputs.website },
            toaster: true,
        })
        setLoader(false)
    }

    useEffect(() => {
        if (agency?.non_saas_email || agency?.non_saas_phone || agency?.non_saas_website) {
            setInputs({ email: agency?.non_saas_email || '', phone: agency?.non_saas_phone || '', website: agency?.non_saas_website || '' })
        }
    }, [agency])

    return (
        <div>
            <input
                type="text"
                placeholder="Email"
                value={inputs.email}
                onChange={(e) => setInputs({ ...inputs, email: e.target.value })}
                style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                    fontSize: "16px",
                    outline: "none",
                }}
            />
            <input
                type="text"
                placeholder="Phone"
                value={inputs.phone}
                onChange={(e) => setInputs({ ...inputs, phone: e.target.value })}
                style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                    fontSize: "16px",
                    outline: "none",
                    marginTop: "10px"
                }}
            />
            <input
                type="text"
                placeholder="Website"
                value={inputs.website}
                onChange={(e) => setInputs({ ...inputs, website: e.target.value })}
                style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                    fontSize: "16px",
                    outline: "none",
                    marginTop: "10px"
                }}
            />
            <div
                style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", width: "100%" }}
            >
                <Button
                    onClick={handleSaveClick}
                    disabled={(!inputs.email && !inputs.phone && !inputs.website) || loader}
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: "10px" }}
                >
                    save
                </Button>
            </div>
        </div>
    )
}

export default NonSaasPlanContactInfo